import {
  useInfiniteQuery,
  useQuery,
  useQueryClient
} from '@tanstack/react-query'

import { getIdentityClient } from '@/api/identity-client'

export const useOidcClients = () =>
  useInfiniteQuery({
    queryKey: ['identity', 'clients'],
    queryFn: async ({ pageParam }) =>
      (await getIdentityClient().listClients({ size: 100, cursor: pageParam }))
        .data,
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.next_cursor || undefined,
    retry: false,
    refetchOnWindowFocus: false
  })

export const useOidcClient = (id: string) =>
  useQuery({
    queryKey: ['identity', 'client', id],
    queryFn: async () =>
      (await getIdentityClient().getOidcClient({ client_id: id })).data,
    enabled: Boolean(id),
    retry: false,
    refetchOnWindowFocus: false
  })

export const useOidcOrganizations = (id: string) =>
  useQuery({
    queryKey: ['identity', 'organizations', id],
    // Explicit form: the generated type of this operation omits its path-level client_id.
    queryFn: async () =>
      (
        await getIdentityClient().listClientOrganizations([
          { name: 'client_id', value: id, in: 'path' }
        ])
      ).data.results,
    enabled: Boolean(id),
    retry: false,
    refetchOnWindowFocus: false
  })

export const useRefreshIdentity = () => {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: ['identity'] })
}
